<script>
    import Dropdown from '@js/components/themes/Dropdown.svelte';
    import Checkbox from '@js/components/themes/Checkbox.svelte';
    import Slider from '@js/components/themes/Slider.svelte';
    import Switch from '@js/components/themes/Switch.svelte';

    const {
        type,
        name,
        elementId,
        elements,
        elementFormatter,
        selectedElements,
        onFilterChange
    } = $props();

    const onCheckboxChange = (element, event) => {
        onFilterChange(type, elementId, element, event.target.checked);
    };

    const onSliderChange = (range) => {
        onFilterChange(type, elementId, range);
    };

    const onSwitchChange = (event) => {
        onFilterChange(type, elementId, event.target.checked);
    };
</script>

<Dropdown color="primary"
          buttonClass="text-white bg-primary-700 border-primary-700 hover:bg-primary-800"
          buttonName={name}>
    {#if type === 'select'}
        <ul class="p-3 space-y-3 text-sm text-gray-700 dark:text-gray-200"
            aria-labelledby="User filter">
            {#each elements as element (element.id)}
                <li>
                    <Checkbox color="primary"
                              checked={selectedElements.has(element.id)}
                              onchange={onCheckboxChange.bind(this, element)}>
                        {element.name}
                    </Checkbox>
                </li>
            {/each}
        </ul>
    {:else if type === 'range'}
        <div class="px-4 pt-3 pb-6">
            <Slider color="primary"
                    min={parseFloat(elements[0])}
                    max={parseFloat(elements[1])}
                    step={Math.round((parseFloat(elements[1]) - parseFloat(elements[0])) / 100)}
                    marks={[
                             parseFloat(elements[0]),
                             parseFloat(elements[1])
                         ]}
                    initialValue={Array.from(selectedElements).map((element) => parseFloat(element))}
                    valueLabelFormat={(value) => (elementFormatter ? elementFormatter(value) : value)}
                    onChange={onSliderChange}/>
        </div>
    {:else if type === 'switch'}
        <div class="p-3">
            <Switch color="primary"
                    labels={elements}
                    checked={selectedElements}
                    onchange={onSwitchChange}/>
        </div>
    {/if}
</Dropdown>
